module.exports = __webpack_public_path__ + "media/icons/smartsearch/colors/green-8c76f8f3a93ceaa8e21a3624ea04775d.png";